const productLabels = {
  "Abonadora_de_granulado_con_ruedas": "Abonadora de granulado con ruedas",
  "Abonadora_de_granulado_mochila": "Abonadora de granulado mochila",
  "Abonadoras_de_granulado": "Abonadoras de granulado",
  "Abonadora_tipo_bolsa": "Abonadora tipo bolsa",
  "Abonda_tipo_bolsa_(2)": "Abonadora tipo bolsa (2)",
  "Ahoyadora_con_carretilla": "Ahoyadora con carretilla",
  "Aspersor_de_agua": "Aspersor de agua",
  "Bomba_de_agua_de_precisión": "Bomba de agua de precisión",
  "Bomba_de_fumigar": "Bomba de fumigar",
  "Bomba_de_fumigar_(2)": "Bomba de fumigar (2)",
  "Desgranadora": "Desgranadora",
  "Desgranadora_de_Maíz_con_motor": "Desgranadora de maíz con motor",
  "Desgranadora_de_Maíz_manual": "Desgranadora de maíz manual",
  "Desgranadora_de_Maíz_manual_con_Base": "Desgranadora de maíz manual con base",
  "Desgranadora_Maiz": "Desgranadora de maíz",
  "Desgranadoras_de_Maiz_doble_rodo": "Desgranadoras de maíz con doble rodo",
  "Desgranadoras_de_Maíz_eléctricas": "Desgranadoras de maíz eléctricas",
  "Esparcidor_de_Semillas": "Esparcidor de semillas",
  "Esparcidor_semillas_de_mochila": "Esparcidor de semillas de mochila",
  "Generador_de_Diesel": "Generador de diésel",
  "Manguera_de_agua": "Manguera de agua",
  "Molino_de_Maíz_eléctrico": "Molino de maíz eléctrico",
  "Molino_Nixtamal": "Molino Nixtamal",
  "Motobomba": "Motobomba",
  "Motocultivador": "Motocultivador",
  "Motocultivador_de_Dientes": "Motocultivador de dientes",
  "Motor_a_Gasolina": "Motor a gasolina",
  "Motosierra": "Motosierra",
  "Peletizadora": "Peletizadora",
  "Peletizadora_Diesel": "Peletizadora diésel",
  "Picadora": "Picadora",
  "Picadora_y_Ensiladora": "Picadora y ensiladora",
  "Rotavitor": "Rotavitor",
  "Sembradora_de_Maíz_con_motor": "Sembradora de maíz con motor",
  "Sembradoras_de_Hortalizas_con_Motor": "Sembradoras de hortalizas con motor",
  "Sembradoras_de_Pilon": "Sembradoras de pilón",
  "Sembradoras_Manuales": "Sembradoras manuales",
  "Sembradoras_Push": "Sembradoras push",
  "Surqueador": "Surqueador",
  "Taladro": "Taladro",
  "Taladro_de_concreto_eléctrico": "Taladro de concreto eléctrico",
  "Termonebulizadora": "Termonebulizadora",
  "Trípode_para_Aspersor_de_agua": "Trípode para aspersor de agua"
};

export default productLabels;
